module.exports = __webpack_public_path__ + "assets/img/Integrity_header.40becee4.jpg";